module.exports = __webpack_public_path__ + "img/infoblock-1.e70daff0.png";